import { __assign } from "tslib";
import cookies from 'js-cookie';
import { merge } from 'lodash-es';
import { format, parse, resolve } from 'url';
function fetchJsonOrEmpty(url, _a) {
    var _b = _a === void 0 ? {} : _a, token = _b.token, projectID = _b.projectID, requestProps = _b.requestProps;
    var savedToken = getOrUpdateToken(projectID, token);
    var request = {
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
        },
    };
    if (savedToken) {
        request.headers['X-Prototype-Token'] = savedToken;
    }
    if (requestProps) {
        request = merge(request, requestProps);
    }
    return fetch(url, request).then(function (res) {
        if (res.ok) {
            // Some backend endpoints can return *either* an empty
            // response or json
            var contentType = res.headers.get('content-type');
            if (process.env.NODE_ENV === 'test' ||
                (contentType && contentType.indexOf('application/json') !== -1)) {
                return res.json();
            }
            return res.text();
        }
        return Promise.reject(res);
    });
}
function getAPIURL() {
    return __assign(__assign({}, parse('/api/')), { query: {} });
}
export function getProject(projectID, token) {
    var url = getAPIURL();
    url.pathname = resolve(url.pathname, "project-retrieve/".concat(projectID, "/"));
    return fetchJsonOrEmpty(format(url), { projectID: projectID, token: token });
}
export function getProjectPreview(projectID, screenID, token) {
    var url = getAPIURL();
    url.pathname = resolve(url.pathname, "prototype/".concat(projectID, "/"));
    if (screenID) {
        url.pathname = resolve(url.pathname, "".concat(screenID, "/"));
    }
    else {
        url.query.limit = 1;
    }
    return fetchJsonOrEmpty(format(url), { projectID: projectID, token: token });
}
export function getHotspots(projectID, token) {
    var url = getAPIURL();
    url.pathname = resolve(url.pathname, "project-hotspots/".concat(projectID, "/"));
    return fetchJsonOrEmpty(format(url), { projectID: projectID, token: token });
}
export function getZip(zipHandoff) {
    var url = getAPIURL();
    url.pathname = resolve(url.pathname, "prototype/assets/");
    return fetchJsonOrEmpty(format(url), {
        requestProps: {
            method: 'POST',
            body: JSON.stringify(zipHandoff),
            headers: {
                'X-CSRFToken': cookies.get('csrftoken'),
                'Content-Type': 'application/json',
            },
        },
    });
}
function getOrUpdateToken(projectID, token) {
    var savedToken;
    if (token) {
        savedToken = token;
        localStorage.setItem(projectID, token);
    }
    else {
        savedToken = localStorage.getItem(projectID);
    }
    return savedToken;
}
